<template>
  <div class="eprights-cont">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'OnlineConsultation',
};
</script>
<style scoped>
</style>
